import logo from './logo.svg';
import './App.css';
import LoginSignup from './components/loginsignup';

function App() {
  return (
    <div>
      <LoginSignup />
    </div>
  );
}

export default App;
